import React, { Fragment } from 'react';

import { CopyTextId } from 'components/CopyTextId';

type Props = {
  id?: string;
  name?: string;
  shouldTruncateId?: boolean;
};

export const UserInfo: React.FC<Props> = ({
  name,
  id,
  shouldTruncateId = true,
}) => (
  <Fragment>
    {name && <div>{name}</div>}
    {id && (
      <CopyTextId id={id} {...(!shouldTruncateId && { truncateLength: 0 })} />
    )}
  </Fragment>
);
